// Romanian cities, towns, and major villages with postal codes
const ROMANIAN_LOCALITIES = [
  { city: 'București - Sector 1', county: 'București', zip: '010000' },
  { city: 'București - Sector 2', county: 'București', zip: '020000' },
  { city: 'București - Sector 3', county: 'București', zip: '030000' },
  { city: 'București - Sector 4', county: 'București', zip: '040000' },
  { city: 'București - Sector 5', county: 'București', zip: '050000' },
  { city: 'București - Sector 6', county: 'București', zip: '060000' },
  { city: 'Alba Iulia', county: 'Alba', zip: '510000' },
  { city: 'Aiud', county: 'Alba', zip: '515200' },
  { city: 'Blaj', county: 'Alba', zip: '515400' },
  { city: 'Sebeș', county: 'Alba', zip: '515800' },
  { city: 'Cugir', county: 'Alba', zip: '515600' },
  { city: 'Arad', county: 'Arad', zip: '310000' },
  { city: 'Ineu', county: 'Arad', zip: '315300' },
  { city: 'Lipova', county: 'Arad', zip: '315400' },
  { city: 'Pecica', county: 'Arad', zip: '315500' },
  { city: 'Curtici', county: 'Arad', zip: '315200' },
  { city: 'Pitești', county: 'Argeș', zip: '110000' },
  { city: 'Câmpulung', county: 'Argeș', zip: '115100' },
  { city: 'Curtea de Argeș', county: 'Argeș', zip: '115300' },
  { city: 'Mioveni', county: 'Argeș', zip: '115400' },
  { city: 'Costești', county: 'Argeș', zip: '115200' },
  { city: 'Bacău', county: 'Bacău', zip: '600000' },
  { city: 'Onești', county: 'Bacău', zip: '601100' },
  { city: 'Moinești', county: 'Bacău', zip: '605400' },
  { city: 'Comănești', county: 'Bacău', zip: '605200' },
  { city: 'Buhuși', county: 'Bacău', zip: '605100' },
  { city: 'Oradea', county: 'Bihor', zip: '410000' },
  { city: 'Beiuș', county: 'Bihor', zip: '415200' },
  { city: 'Salonta', county: 'Bihor', zip: '415500' },
  { city: 'Marghita', county: 'Bihor', zip: '415300' },
  { city: 'Bistrița', county: 'Bistrița-Năsăud', zip: '420000' },
  { city: 'Năsăud', county: 'Bistrița-Năsăud', zip: '425200' },
  { city: 'Beclean', county: 'Bistrița-Năsăud', zip: '425100' },
  { city: 'Botoșani', county: 'Botoșani', zip: '710000' },
  { city: 'Dorohoi', county: 'Botoșani', zip: '715200' },
  { city: 'Darabani', county: 'Botoșani', zip: '715100' },
  { city: 'Brăila', county: 'Brăila', zip: '810000' },
  { city: 'Ianca', county: 'Brăila', zip: '815200' },
  { city: 'Făurei', county: 'Brăila', zip: '815100' },
  { city: 'Brașov', county: 'Brașov', zip: '500000' },
  { city: 'Făgăraș', county: 'Brașov', zip: '505200' },
  { city: 'Săcele', county: 'Brașov', zip: '505600' },
  { city: 'Codlea', county: 'Brașov', zip: '505100' },
  { city: 'Zărnești', county: 'Brașov', zip: '505800' },
  { city: 'Râșnov', county: 'Brașov', zip: '505400' },
  { city: 'Predeal', county: 'Brașov', zip: '505300' },
  { city: 'Buzău', county: 'Buzău', zip: '120000' },
  { city: 'Râmnicu Sărat', county: 'Buzău', zip: '125300' },
  { city: 'Călărași', county: 'Călărași', zip: '910000' },
  { city: 'Oltenița', county: 'Călărași', zip: '915400' },
  { city: 'Reșița', county: 'Caraș-Severin', zip: '320000' },
  { city: 'Caransebeș', county: 'Caraș-Severin', zip: '325100' },
  { city: 'Oravița', county: 'Caraș-Severin', zip: '325600' },
  { city: 'Cluj-Napoca', county: 'Cluj', zip: '400000' },
  { city: 'Turda', county: 'Cluj', zip: '401500' },
  { city: 'Dej', county: 'Cluj', zip: '405200' },
  { city: 'Câmpia Turzii', county: 'Cluj', zip: '405100' },
  { city: 'Gherla', county: 'Cluj', zip: '405300' },
  { city: 'Florești', county: 'Cluj', zip: '407280' },
  { city: 'Constanța', county: 'Constanța', zip: '900000' },
  { city: 'Mangalia', county: 'Constanța', zip: '905500' },
  { city: 'Medgidia', county: 'Constanța', zip: '905600' },
  { city: 'Năvodari', county: 'Constanța', zip: '905700' },
  { city: 'Cernavodă', county: 'Constanța', zip: '905200' },
  { city: 'Sfântu Gheorghe', county: 'Covasna', zip: '520000' },
  { city: 'Târgu Secuiesc', county: 'Covasna', zip: '525400' },
  { city: 'Târgoviște', county: 'Dâmbovița', zip: '130000' },
  { city: 'Moreni', county: 'Dâmbovița', zip: '135300' },
  { city: 'Pucioasa', county: 'Dâmbovița', zip: '135400' },
  { city: 'Craiova', county: 'Dolj', zip: '200000' },
  { city: 'Băilești', county: 'Dolj', zip: '207100' },
  { city: 'Calafat', county: 'Dolj', zip: '205200' },
  { city: 'Filiași', county: 'Dolj', zip: '205300' },
  { city: 'Galați', county: 'Galați', zip: '800000' },
  { city: 'Tecuci', county: 'Galați', zip: '805300' },
  { city: 'Giurgiu', county: 'Giurgiu', zip: '080000' },
  { city: 'Bolintin-Vale', county: 'Giurgiu', zip: '085100' },
  { city: 'Târgu Jiu', county: 'Gorj', zip: '210000' },
  { city: 'Motru', county: 'Gorj', zip: '215200' },
  { city: 'Rovinari', county: 'Gorj', zip: '215400' },
  { city: 'Miercurea Ciuc', county: 'Harghita', zip: '530000' },
  { city: 'Odorheiu Secuiesc', county: 'Harghita', zip: '535600' },
  { city: 'Gheorgheni', county: 'Harghita', zip: '535500' },
  { city: 'Deva', county: 'Hunedoara', zip: '330000' },
  { city: 'Hunedoara', county: 'Hunedoara', zip: '331000' },
  { city: 'Petroșani', county: 'Hunedoara', zip: '332000' },
  { city: 'Lupeni', county: 'Hunedoara', zip: '335600' },
  { city: 'Orăștie', county: 'Hunedoara', zip: '335700' },
  { city: 'Slobozia', county: 'Ialomița', zip: '920000' },
  { city: 'Fetești', county: 'Ialomița', zip: '925100' },
  { city: 'Urziceni', county: 'Ialomița', zip: '925300' },
  { city: 'Iași', county: 'Iași', zip: '700000' },
  { city: 'Pașcani', county: 'Iași', zip: '705200' },
  { city: 'Hârlău', county: 'Iași', zip: '705100' },
  { city: 'Târgu Frumos', county: 'Iași', zip: '705300' },
  { city: 'Voluntari', county: 'Ilfov', zip: '077190' },
  { city: 'Pantelimon', county: 'Ilfov', zip: '077145' },
  { city: 'Buftea', county: 'Ilfov', zip: '070000' },
  { city: 'Popești-Leordeni', county: 'Ilfov', zip: '077160' },
  { city: 'Bragadiru', county: 'Ilfov', zip: '077025' },
  { city: 'Otopeni', county: 'Ilfov', zip: '075100' },
  { city: 'Măgurele', county: 'Ilfov', zip: '077125' },
  { city: 'Baia Mare', county: 'Maramureș', zip: '430000' },
  { city: 'Sighetu Marmației', county: 'Maramureș', zip: '435500' },
  { city: 'Borșa', county: 'Maramureș', zip: '435200' },
  { city: 'Vișeu de Sus', county: 'Maramureș', zip: '435700' },
  { city: 'Drobeta-Turnu Severin', county: 'Mehedinți', zip: '220000' },
  { city: 'Orșova', county: 'Mehedinți', zip: '225200' },
  { city: 'Târgu Mureș', county: 'Mureș', zip: '540000' },
  { city: 'Sighișoara', county: 'Mureș', zip: '545400' },
  { city: 'Reghin', county: 'Mureș', zip: '545300' },
  { city: 'Târnăveni', county: 'Mureș', zip: '545600' },
  { city: 'Piatra Neamț', county: 'Neamț', zip: '610000' },
  { city: 'Roman', county: 'Neamț', zip: '611000' },
  { city: 'Târgu Neamț', county: 'Neamț', zip: '615200' },
  { city: 'Slatina', county: 'Olt', zip: '230000' },
  { city: 'Caracal', county: 'Olt', zip: '235200' },
  { city: 'Balș', county: 'Olt', zip: '235100' },
  { city: 'Ploiești', county: 'Prahova', zip: '100000' },
  { city: 'Câmpina', county: 'Prahova', zip: '105600' },
  { city: 'Băicoi', county: 'Prahova', zip: '105200' },
  { city: 'Sinaia', county: 'Prahova', zip: '106100' },
  { city: 'Bușteni', county: 'Prahova', zip: '105500' },
  { city: 'Vălenii de Munte', county: 'Prahova', zip: '106400' },
  { city: 'Zalău', county: 'Sălaj', zip: '450000' },
  { city: 'Șimleu Silvaniei', county: 'Sălaj', zip: '455300' },
  { city: 'Jibou', county: 'Sălaj', zip: '455200' },
  { city: 'Satu Mare', county: 'Satu Mare', zip: '440000' },
  { city: 'Carei', county: 'Satu Mare', zip: '445100' },
  { city: 'Negrești-Oaș', county: 'Satu Mare', zip: '445200' },
  { city: 'Sibiu', county: 'Sibiu', zip: '550000' },
  { city: 'Mediaș', county: 'Sibiu', zip: '551000' },
  { city: 'Cisnădie', county: 'Sibiu', zip: '555300' },
  { city: 'Agnita', county: 'Sibiu', zip: '555100' },
  { city: 'Suceava', county: 'Suceava', zip: '720000' },
  { city: 'Fălticeni', county: 'Suceava', zip: '725200' },
  { city: 'Rădăuți', county: 'Suceava', zip: '725400' },
  { city: 'Câmpulung Moldovenesc', county: 'Suceava', zip: '725100' },
  { city: 'Vatra Dornei', county: 'Suceava', zip: '725700' },
  { city: 'Alexandria', county: 'Teleorman', zip: '140000' },
  { city: 'Turnu Măgurele', county: 'Teleorman', zip: '145200' },
  { city: 'Roșiorii de Vede', county: 'Teleorman', zip: '145100' },
  { city: 'Timișoara', county: 'Timiș', zip: '300000' },
  { city: 'Lugoj', county: 'Timiș', zip: '305500' },
  { city: 'Sânnicolau Mare', county: 'Timiș', zip: '305600' },
  { city: 'Jimbolia', county: 'Timiș', zip: '305400' },
  { city: 'Dumbrăvița', county: 'Timiș', zip: '307160' },
  { city: 'Giroc', county: 'Timiș', zip: '307220' },
  { city: 'Tulcea', county: 'Tulcea', zip: '820000' },
  { city: 'Babadag', county: 'Tulcea', zip: '825100' },
  { city: 'Măcin', county: 'Tulcea', zip: '825300' },
  { city: 'Râmnicu Vâlcea', county: 'Vâlcea', zip: '240000' },
  { city: 'Drăgășani', county: 'Vâlcea', zip: '245700' },
  { city: 'Horezu', county: 'Vâlcea', zip: '245800' },
  { city: 'Vaslui', county: 'Vaslui', zip: '730000' },
  { city: 'Bârlad', county: 'Vaslui', zip: '731100' },
  { city: 'Huși', county: 'Vaslui', zip: '735100' },
  { city: 'Focșani', county: 'Vrancea', zip: '620000' },
  { city: 'Adjud', county: 'Vrancea', zip: '625100' },
  { city: 'Panciu', county: 'Vrancea', zip: '625400' },
];

export default ROMANIAN_LOCALITIES;
